// extracted by mini-css-extract-plugin
export default {"header":"FoldedComments_header__A1ory","foldedArrow":"FoldedComments_foldedArrow__HoO8y","open":"FoldedComments_open__tQWJw"};